import gql from 'graphql-tag'

export const fetchCommercialBaseSelect = role_id => {
	return {
		query: gql`
			query ($role_id: bigint!) {
				commercial_base: roles_commercial_base(
					where: { role_id: { _eq: $role_id } }
				) {
					conf_comercial_base {
						id
						base
					}
				}
			}
		`,
		variables: { role_id },
		update: data =>
			data.commercial_base.map(({ conf_comercial_base }) => conf_comercial_base)
	}
}
